// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__sETTR","mainLayout":"Home_mainLayout__HZOyA","chatPanel":"Home_chatPanel___aXMi","chatContainer":"Home_chatContainer___U3TS"};